import script from "./Attachments.vue?vue&type=script&setup=true&lang=ts"
export * from "./Attachments.vue?vue&type=script&setup=true&lang=ts"

import "./Attachments.vue?vue&type=style&index=0&id=1064c7f8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1064c7f8"]])

export default __exports__